module.exports = __webpack_public_path__ + "static/media/about.46670d39.png";